<template>
  <div class="dashboard">

    <!-- Mobile hamburger button -->
    <button class="hamburger" @click="sidebarOpen = true" aria-label="Open menu">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- Dark overlay (mobile only) -->
    <div
      class="sidebar-overlay"
      :class="{ 'is-active': sidebarOpen }"
      @click="sidebarOpen = false"
    ></div>

    <!-- Sidebar -->
    <app-menu
      :menuActive="setMenuItem()"
      :class="{ 'is-open': sidebarOpen }"
      @close="sidebarOpen = false"
    />

    <!-- Main content -->
    <div class="main-content">
      <app-search    v-if="menuItem === 'search'"    />
      <app-overview  v-else-if="menuItem === 'overview'"  />
      <app-users     v-else-if="menuItem === 'users'"     />
      <app-add-paper v-else-if="menuItem === 'add-paper'" />
    </div>

  </div>
</template>

<script>
import Menu from './Menu'
import Search from '../Papers/Search'
import Overview from '../Papers/Overview'
import Users from './Users'
import AddPaper from './AddPaper.vue'

export default {
  components: {
    'app-menu': Menu,
    'app-users': Users,
    'app-search': Search,
    'app-overview': Overview,
    'app-add-paper': AddPaper
  },
  data () {
    return {
      menuItem: this.$route.params.menu,
      sidebarOpen: false
    }
  },
  methods: {
    setMenuItem () {
      if (this.$route.params.menu === undefined) {
        this.$router.push('/papers/search')
      } else {
        this.menuItem = this.$route.params.menu
        return this.menuItem
      }
    }
  }
}
</script>

<style scoped>
.dashboard {
  display: flex;
  min-height: 100vh;
  position: relative;
}

/* ── Main content ── */
.main-content {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
  margin-left: 220px; /* matches sidebar width */
}

/* ── Hamburger (mobile only) ── */
.hamburger {
  display: none;
  position: fixed;
  top: 14px;
  left: 14px;
  z-index: 300;
  background: #1b3d2f;
  border: none;
  border-radius: 6px;
  padding: 8px 9px;
  cursor: pointer;
  flex-direction: column;
  gap: 4px;
}

.hamburger span {
  display: block;
  width: 18px;
  height: 2px;
  background: #f0ede6;
  border-radius: 2px;
}

/* ── Overlay (mobile only) ── */
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 150;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s;
}

/* ── Mobile breakpoint ── */
@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: 1rem;
    padding-top: 56px; /* space for hamburger button */
  }

  .hamburger {
    display: flex;
  }

  .sidebar-overlay {
    display: block;
  }

  .sidebar-overlay.is-active {
    opacity: 1;
    pointer-events: all;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/UserDashboard.vue